module.exports = __webpack_public_path__ + "static/head-bg.5f54c7a1.png";